import { useApiGetPraktikKinerjaPelaksanaanSummary } from 'api/kinerja/pengawas-sekolah/pelaksanaan'
import { usePSStatus } from './useSummary'

import type { QueryStatus } from 'react-query'
import type { TPraktikKinerjaSummaryRes } from 'types/kinerja-ps-pegawai'

type TPelaksanaanPraktikKinerjaSummary = {
  pelaksanaanPraktikKinerjaSummaryFetchStatus: QueryStatus
  pelaksanaanPraktikKinerjaSummary: TPraktikKinerjaSummaryRes
}
export const usePelaksanaanPraktikKinerjaSummary =
  (): TPelaksanaanPraktikKinerjaSummary => {
    const { summary } = usePSStatus()

    const {
      data: pelaksanaanPraktikKinerjaSummary,
      status: pelaksanaanPraktikKinerjaSummaryFetchStatus,
    } = useApiGetPraktikKinerjaPelaksanaanSummary({
      skpPsId: summary?.skpPsId,
      opts: {
        enabled: Boolean(summary?.skpPsId),
      },
    })

    return {
      pelaksanaanPraktikKinerjaSummaryFetchStatus,
      pelaksanaanPraktikKinerjaSummary,
    }
  }
